import api from '../api';

export const removeProvinceFromRegion = async (projectId, regionId, provinceId) => {
  const res = await api.delete(`/projects/${projectId}/regions/${regionId}/provinces/${provinceId}`);
  return res.data;
};

export const deleteRegion = async (projectId, regionId) => {
  const res = await api.delete(`/projects/${projectId}/regions/${regionId}`);
  return res.data;
};

export const addProvinceToRegion = async (projectId, regionId, provinceId) => {
  const res = await api.patch(`/projects/${projectId}/regions/${regionId}`, { provinceId });
  return res.data;
};

export const updateRegion = async (projectId, regionId, regionData) => {
  const res = await api.put(`/projects/${projectId}/regions/${regionId}`, regionData);
  return res.data;
};

export const createRegion = async (projectId, regionData) => {
  const res = await api.post(`/projects/${projectId}/regions/`, regionData);
  return res.data;
};

export const getRegionsWithProvinces = async (projectId) => {
  const res = await api.get(`/projects/${projectId}/regions`);
  return res.data;
};

export const getRegionsWithAreas = async (projectId) => {
  const res = await api.get(`/projects/${projectId}/regions/with-areas`);
  return res.data;
};

export const exportRegion = async (projectId) => {
  const res = await api.get(`/projects/${projectId}/regions/export`, {
    responseType: 'blob' });
  const cd = res.headers['content-disposition'] || '';
  const match = cd.match(/filename="?(?<fn>[^"]+)"?/i);
  const filename = match?.groups?.fn || `region-config-p${projectId}.json`;

  const blob = new Blob([res.data], { type: 'application/json' });
  const objectUrl = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = objectUrl;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(objectUrl);
}

export const importRegion = async (projectId, file) => {
  const text = await file.text(); // read file contents
  const data = JSON.parse(text);

  const res = await api.post(`/projects/${projectId}/regions/import`, { projectId, data });
  return res.data;
};